import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';
import {listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class WaitForRoundStartAct extends SyncUIActDecorator {
    public execute(): void {
        listenUIDisabled(this);

        this.emitter.on('UI.spinButton.pressed', this.onSpinStartedByButton.bind(this));
        this.emitter.on('UI.holdSpinForAction.started', this.onHoldSpinForActionStarted.bind(this));

        this.emitter.once('Game.command.round.started', () => {
            slotStore.batchUpdate({feature_type: {type: 'spin'}});
            this.onExecuted?.();
        });
        this.emitter.on('Game.command.round.featureStarted', (data: FeatureEventData) => {
            slotStore.batchUpdate({
                feature_type: data
            });

            this.removeAllListeners();
            this.onExecuted?.();
        });
    }

    protected onSpinStartedByButton(): void {
        this.emitter.emit('UI.command.spin');
    }

    protected onHoldSpinForActionStarted(): void {
        slotStore.isHoldForTurboMode.value = true;
        this.onExecuted?.();
    }

    getName(): string {
        return 'WaitForRoundStartAct';
    }
}